const {h, render, Component} = require('preact');
const SeeGrouponPlusView = require('./see_all_claims');
const SpinnerView = require('../../views/common/spinner')

class ClaimsView extends Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
        <div id="help-wizard" className="help-wizard" style="display: block;">
          <div className="help-wizard-content">
            <div className="row select-claim-menu">
              <div className={this.props.page=='listing'?'row claim-listing':'row claim-listing landing'} data-bhw="web2018_claims_landing">
                <div>
                  <div id="claimsTablewrapper">
                    <table width="100%" className="scrollableTable">
                      <tbody id="claimsTable">
                      {this.props.claimsTable()}
                      </tbody>
                    </table>
                    {this.props.isLoadingInProgress?<SpinnerView/>:null}
                    {!this.props.isLoadingInProgress && <SeeGrouponPlusView length={this.props.length} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  }
}

module.exports = ClaimsView
